const AccountCircleIcon = ({ style, width = '24px', height = '24px', ...props }) => {
    return (
        <img
            src="/icons/account-circle.svg"
            alt="Account"
            width={width}
            height={height}
            style={{ display: 'block', ...style }}
            {...props}
        />
    );
};

export default AccountCircleIcon;
